import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../store/store';
import baseServices from "../../services/base.services";
import  moment from 'moment'

//import { fetchCount } from './counterAPI';

export interface DataLog {
  code: string;
  username: string;
  logMessage: string;
  name: string;
  lastname: string;
  date: string;
  tagStatus: string;
  status: number;
}


export interface DataComment {
  idComment: string;
  comment: string;
  rut: string;
  name: string;
  lastname: string;
  status: string;
  date: string;
  tagStatus: string;
  dateUpdate: string;
  log: Array<DataLog>;
}


export interface AdminState {
  selectedRange: string;
  selectedTabs: any;
  vistaSearch: any
  status: 'idle' | 'loading' | 'failed';
  data: Array<DataComment>;
  comment: String;
}

const initialState: AdminState = {
  selectedRange: 'D',
  selectedTabs: {id: 1, name: 'Recibido'},
  status: 'idle',
  vistaSearch: false,
  data: [],
  comment: ''
};

//////////////////////////
export const getAllResults = createAsyncThunk(
  'range/getAllResults',
  async (_props: any) => {
    var data: any = {};
    
    const response1 = await baseServices.getAllResults({ 
      period: _props.period
    });

    const response2 = await baseServices.getLogMessage({ 
      period: _props.period
    });
    // The value we return becomes the `fulfilled` action payload
    return {data: response1.data, log: response2.data}
  }
);

export const addNewLogMessage = createAsyncThunk(
  'range/addNewLogMessage',
  async (_props: any) => {

    {/*@ts-ignore*/}
    var user = JSON.parse(localStorage.getItem('user'));
    const response1 = await baseServices.addLogMessage({ 
      Code: _props.item.idComment,
      Username: user.data.Username,
      LogMessage: _props.LogMessage,
      Status: _props.item.status,
    });
    // The value we return becomes the `fulfilled` action payload
    return response1.data[0];
  }
);


export const setStatus = createAsyncThunk(
  'range/setStatus',
  async (_props: any) => {
    var data: any = {};
    {/*@ts-ignore*/}
    var user = JSON.parse(localStorage.getItem('user'));
    const response1 = await baseServices.setStatus({ 
      Code: _props.idComment,
      Status: _props.status,
      Username: user.data.Username
    });
    // The value we return becomes the `fulfilled` action payload
    return response1.data
  }
);


export const AdminSlice = createSlice({
  name: 'range',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    
    changeSearch: (state: AdminState, action: any) => {
      state.vistaSearch = !state.vistaSearch;
      if(action.payload || action.payload == ''){
        var data:any = [];        
//        var dataList =  state.data.filter(x => x.name.toLowerCase().includes(action.payload.toLowerCase())).map(x=> {return x});
        }
        
    },
    changeTabs: (state: AdminState, action:any) => {
      state.selectedTabs = action.payload;
    },
    changeRangeDate: (state: AdminState, action:any) => {
      state.selectedRange = action.payload;
    },

    changeComment: (state: AdminState, action:any) => {
      state.comment = action.payload;
    },
  
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder : any) => {
    builder

      .addCase(getAllResults.pending, (state: AdminState) => {
        state.status = 'loading';
      
      })
      .addCase(getAllResults.fulfilled, (state: AdminState, action: any) => {

        {/*@ts-ignore*/}
        state.status = 'idle';
      
        state.data = action.payload.data.map((x: any)=> {return { 

          idComment: x.Code,
          comment: x.Response,
          rut: x.Rut,
          name: x.Name,
          lastname: x.Lastname,
          status: x.Status,
          date: moment(x.Date).format('DD-MM-YYYY HH:mm'),
          tagStatus: x.TagStatus,
          dateUpdate : moment(x.DateUpdate).format('DD-MM-YYYY HH:mm'),
          log: action.payload.log.filter((l: any)=> l.Code == x.Code).map((item: any) => {
            return {
              code: item.Code,
              username: item.Username,
              logMessage: item.LogMessage,
              name: item.Name,
              lastname: item.Lastname,
              date: moment(item.Date).format('DD-MM-YYYY HH:mm'),
              tagStatus: item.TagStatus,
              status: item.Status,
            }
          })
        }});
        
      })
      .addCase(setStatus.pending, (state: AdminState) => {
        state.status = 'loading';
      })
      .addCase(setStatus.fulfilled, (state: AdminState, action: any) => {
        state.status = 'idle';    
        {/*@ts-ignore*/}
//        state.data = state.data.find(x=> x.idComment == action.payload.idComment).map(x=> x.status = action.payload.status);
      })
      .addCase(addNewLogMessage.pending, (state: AdminState) => {
        state.status = 'loading';
      })
      .addCase(addNewLogMessage.fulfilled, (state: AdminState, action: any) => {
        state.status = 'idle';    
        state.comment = '';    {
          /*@ts-ignore*/}
        state.data.find(f=> f.idComment == action.payload.Code).log.push({
            code: action.payload.Code,
            username: action.payload.Username,
            logMessage: action.payload.LogMessage,
            name: action.payload.Name,
            lastname: action.payload.Lastname,
            date: moment(action.payload.Date).format('DD-MM-YYYY HH:mm'),
            tagStatus: action.payload.TagStatus,
            status: action.payload.Status,
          
        });

        {/*@ts-ignore*/}
//        state.data = state.data.find(x=> x.idComment == action.payload.idComment).map(x=> x.status = action.payload.status);
      })
  },
});

export const { changeRangeDate, changeTabs, changeSearch, changeComment } = AdminSlice.actions;
export const selectedDateRange = (state: RootState) => state.adminPageReducer.selectedRange;
export const selectedTabs = (state: RootState) => state.adminPageReducer.selectedTabs;


export default AdminSlice.reducer;
